<template>
  <div class="exchange-white">
    <!-- 白名单弹窗 -->
    <el-dialog
      title="白名单"
      :visible.sync="dialogVisible"
      width="1000px"
      :show-close="true"
      :before-close="handleClose"
    >
      <jd-tips>
        <span
          >登记白名单的用户将不受活动参与条件限制，只要用户有足够的积分数，即可参与兑换奖品，但具体的可兑换次数和限制依旧生效</span
        >
      </jd-tips>
      <div class="exchange-white-btn">
        <el-button type="primary" style="width: auto;" @click="handleAdd"
          >添加参与白名单</el-button
        >
      </div>
      <!-- 白名单列表 -->
      <el-table
        v-loading="tableLoading"
        :data="whitelistData"
        row-key="id"
        max-height="550"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%; border: 1px solid #eee"
      >
        <el-table-column prop="chaosPin" label="用户PIN"></el-table-column>
        <el-table-column prop="updateTime" label="添加时间"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="exchange-white-pagination">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page.sync="pageInfo.current"
          :page-size.sync="pageInfo.size"
          :total="pageInfo.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </el-dialog>

    <!-- 添加参与白名单弹窗 -->
    <el-dialog
      title="新增白名单"
      width="500px"
      :visible.sync="addDialog"
      append-to-body
      :before-close="handleAddClose"
    >
      <el-form
        ref="addFormRef"
        :model="addForm"
        :rules="addRules"
        class="new-input-box"
        label-width="auto"
      >
        <el-form-item label="添加方式：" prop="method">
          <el-radio-group
            v-model="addForm.addType"
            @change="handleAddTypeChange"
          >
            <el-radio :label="1">手动填写</el-radio>
            <el-radio :label="2">导入名单</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 手动填写 -->
        <el-form-item
          v-if="addForm.addType === 1"
          key="manual"
          label="用户PIN："
          prop="customerPin"
        >
          <el-input
            v-model="addForm.customerPin"
            placeholder="请输入京东账号名"
          ></el-input>
          <div class="exchange-white-hint">多个请用英文"，"隔开</div>
        </el-form-item>
        <!-- 导入名单 -->
        <el-form-item v-else key="import" label="上传文件：" prop="fileUrl">
          <div>
            <div class="exchange-white-download">
              <span>点击</span>
              <span
                class="exchange-white-download-link"
                @click="handleDownloadTemplate"
                >下载模板</span
              >
            </div>
            <el-upload
              ref="upload"
              drag
              accept=".xls,.xlsx"
              class="upload-box"
              action=""
              :auto-upload="false"
              :limit="1"
              :file-list="filelist"
              :on-change="handleChange"
              :on-remove="handleFileRemove"
            >
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleAddClose">取消</el-button>
        <el-button type="primary" @click="handleAddConfirm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  pointActivityWhite,
  pointActivityAddOrUpdate,
  uploadWhiteListFile,
  deleteWhiteList,
} from "@/api/integralCenter/PointActivityAnalyticController";
import jdTips from "@/components/common/jdTips.vue";
export default {
  name: "exchangeWhiteList",
  components: {
    jdTips,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    whiteRow: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 接口暂未接入，白名单数据先存本地
      tableLoading: false,
      whitelistData: [],
      addDialog: false,
      addForm: {
        customerPin: "",
        addType: 1,
        fileName: "",
        fileUrl: "",
      },
      // 导入名单相关
      importFile: null,
      addRules: {
        customerPin: [
          { required: true, message: "请输入用户PIN", trigger: "blur" },
          {
            // 多个PIN仅支持英文逗号隔开
            validator: (rule, value, callback) => {
              if (value && /[，、；;\s]/.test(value)) {
                callback(new Error("多个用户PIN仅支持使用英文逗号隔开"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        // 导入名单需先上传文件
        fileUrl: {
          required: true,
          message: "请上传文件",
          trigger: "change",
        },
      },
      pageInfo: {
        current: 1,
        size: 10,
        total: 0,
      },
      filelist: [],
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  created() {
    this.getDataList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageInfo.size = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.pageInfo.current = val;
      this.getDataList();
    },
    getDataList() {
      const query = {
        current: this.pageInfo.current,
        size: this.pageInfo.size,
        activityId: this.whiteRow.id,
        activityType: 2,
      };
      this.tableLoading = true;
      pointActivityWhite(query)
        .then((res) => {
          this.tableLoading = false;
          this.whitelistData = res.data.records;
          this.pageInfo.total = Number(res.data.total);
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 添加参与白名单
    handleAdd() {
      this.addForm.addType = 1;
      this.addForm.customerPin = "";
      this.addForm.fileUrl = "";
      this.addForm.fileName = "";
      this.filelist = [];
      this.$refs.upload && this.$refs.upload.clearFiles();
      this.addDialog = true;
    },
    // 添加弹窗关闭
    handleAddClose() {
      this.addDialog = false;
      this.importFile = null;
      this.$refs.addFormRef && this.$refs.addFormRef.resetFields();
    },
    // 切换添加方式时清空校验提示
    handleAddTypeChange() {
      this.$nextTick(() => {
        this.$refs.addFormRef && this.$refs.addFormRef.clearValidate();
      });
    },
    // 保存添加的白名单
    handleAddConfirm() {
      this.$refs.addFormRef.validate((valid) => {
        if (!valid) return;
        const params = {
          ...this.addForm,
          activityType: 2,
          activityId: this.whiteRow.id,
        };
        try {
          pointActivityAddOrUpdate(params).then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.handleAddClose();
              this.getDataList();
            } else {
              this.$message.error(res.message);
            }
          });
        } catch (error) {}
      });
    },
    // 导入名单的文件选择
    handleChange(file, fileList) {
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      if (!/\.(xls|xlsx)$/i.test(type || "")) {
        this.$message.warning("仅支持xls、xlsx格式的文件");
        this.handleFileReset();
        return false;
      }
      if (file.size > 50 * 1024 * 1024) {
        this.$message.warning("文件大小不能超过50MB");
        this.handleFileReset();
        return false;
      }
      let form = new FormData();
      form.append("file", file.raw);
      uploadWhiteListFile(5, form).then((res) => {
        if (res.code == 1) {
          this.addForm.fileUrl = res.data.fileUrl;
          this.addForm.fileName = file.fileName;
          this.$message.success("上传成功");
          // 上传成功后清除“请上传文件”的校验提示
          this.$nextTick(() => {
            this.$refs.addFormRef &&
              this.$refs.addFormRef.validateField("fileUrl");
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 导入名单的文件移除
    handleFileRemove() {
      this.filelist = [];
      this.addForm.fileUrl = "";
      this.addForm.fileName = "";
    },
    handleFileReset() {
      this.importFile = null;
      this.$refs.upload && this.$refs.upload.clearFiles();
    },
    // 导入名单保存（后端导入接口待接入，先抛出文件）
    handleImportConfirm() {
      if (!this.importFile) {
        this.$message.warning("请上传文件");
        return;
      }
      this.$emit("import", {
        file: this.importFile,
        activityId: this.whiteRow.id,
      });
      this.handleAddClose();
    },
    // 下载导入模板
    handleDownloadTemplate() {
      let url =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E7%A7%AF%E5%88%86%E5%85%91%E6%8D%A2%E7%99%BD%E5%90%8D%E5%8D%95%E6%A8%A1%E6%9D%BF.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      document.body.appendChild(elem);
      elem.click();
    },
    // 删除白名单
    handleDelete(row) {
      this.$confirm("是否删除该白名单用户吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          try {
            deleteWhiteList({
              id: row.id,
              activityId: this.whiteRow.id,
              activityType: 2,
            }).then((res) => {
              if (res.code == 1) {
                this.$message.success("删除成功");
                this.getDataList();
              } else {
                this.$message.error(res.message);
              }
            });
          } catch (error) {}
        })
        .catch(() => {});
    },
    // 弹窗关闭
    handleClose(done) {
      if (typeof done === "function") {
        done();
      }
      this.$emit("input", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.exchange-white {
  &-btn {
    margin: 20px 0 16px;
  }
  &-hint {
    margin-top: 8px;
    font-size: 12px;
    line-height: 1;
    color: #999;
  }
  &-download {
    color: #333;
    &-link {
      margin-left: 4px;
      color: #7b61ff;
      cursor: pointer;
    }
  }
  &-pagination {
    margin-top: 16px;
    text-align: right;
  }
}
/deep/.el-upload-dragger {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
